<template>
  <div class="cs-demo-image__lazy" v-loading="isLoading" v-show="isVisible">
    <div class="block cs-demo-image-container">
      <img :src="imgUrl" lazy>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-demo-image__lazy {
  .block {
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
</style>

<script>
import { getSharedAccessSignature } from "../../service/blobStorage.service";
export default {
  props: {
    isVisible: Boolean,
    src: String
  },
  data() {
    return {
      isLoading: false,
      sasKey: ""
    };
  },
  created() {
    this.isLoading = true;
    getSharedAccessSignature(true)
      .then(result => {
        if (!!result && result.success) {
          this.sasKey = result.data;
        }
        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;
      });
  },
  computed: {
    imgUrl: function() {
      if (!this.sasKey) {
        return "";
      }
      return this.src + this.sasKey;
    }
  },
  watch: {
    isVisible: function() {
      if (!this.isVisible) {
        
      }      
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/fileHandler/imageShow.vue